import { mc } from "@lss/common/game/characters/MC";
import { images, uiImages } from "@lss/common/game/story/images";
import ImageClass from "@lss/common/src/shell/Image";
import { Insta } from "../../src/components/insta/InstaClass";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import Game from "../../src/shell/Game";
import Question from "../../src/shell/Questions";
import UI from "../../src/shell/UI";
import { jump } from "../../src/shell/jump";
import { alex } from "../characters/Alex";
import { ann } from "../characters/Ann";
import { empty } from "../characters/empty";
import { joe } from "../characters/Joe";
import { pcLady } from "../characters/PCLady";
import { vanessa } from "../characters/Vanessa";
import { getAlexInstaData } from "../helpers/alexInstaHelpers";
import { alexImages, alexOtherPics, alexProfilesPic } from "../helpers/alexInstaImages";
import { checkWordInArray, getInstaImage } from "../helpers/helpers";
import { getInstaData } from "../helpers/InstaPostsHelpers";
import { AnnAfterTODLove1 } from "./V3_AnnAtMC";
import { AnnAfterTODNotLove } from "./V3_AnnHateLibrary";
import { JoeGym1 } from "./V3_JoeyGym";
import { VanessaCoffee1 } from "./V3_VanessaCoffeeshop";
import { RoomAfterEventsPassedTime } from "./V4";


export const AfterTOD = async () => {
    ImageClass.setImage(images.v1.RoomAlone_2);
    if (mc.properties.annStatus === "hate") {
        mc.think(`Wait, what's that?`);
        ImageClass.setImage(images.v3.RoomBook1);
        mc.think(`That's Ann's book.`);
        mc.think(`I didn't see it yesterday, it must have fallen off the bed while I was sleeping.`);
        ImageClass.setImage(images.v3.RoomBook2);
        mc.think(`"Mary didn't know what flavor ice cream to choose."`);
        mc.think(`"She asked the salesman for his advice and he replied: "You should take the one you think tastes better"."`);
        mc.think(`"Mary likes strawberries, but she asked for two scoops of vanilla."`);
        mc.think(`What the fuck is she reading? Did she run out of books to read?`);
        ImageClass.setImage(images.v1.RoomAlone_2);
        mc.think(`I hear noises from the living room, I think Joe and Vanessa are up.`);
        mc.think(`I can check what's going on with Alex before checking in on them.`);
    }

    if (Question.globalAnswers.afterTODEnteredNaked) {
        // Ann woke up screaming and left, met Joe and Vanessa in the living room.
        if (mc.properties.annStatus !== "hate") {
            joe.talk(`${mc.name}!!!`, { method: "Shouting" });
            mc.think(`Joey is calling me from the living room.`);
            mc.think(`Let's go and see what he wants.`);

            ImageClass.setImage(images.v3.LivingRoomJoeVanessa1);
            mc.talk(`Hey Joey, did you call me?`);
            joe.talk(`Yes, did you manage to get her on the phone?`);
            mc.talk(`No, she is not answering.`);
            ImageClass.setImage(images.v3.LivingRoomJoeVanessa2);
            vanessa.talk(`I said I'll talk to her.`);
            mc.talk(`Ok great.`);
            if (mc.properties.annStatus === "natural") {
                mc.talk(`I don't really know her. I don't want her to think of me as a douche.`);
                ImageClass.setImage(images.v3.LivingRoomJoeVanessa2);
                vanessa.talk(`So you need to stop sleeping naked next to girls you don't know...`);
                mc.talk(`Are you serious right now?`);
            }
            if (mc.properties.annStatus === "gf") {
                mc.talk(`Just when things were heading on the right direction...`);
                ImageClass.setImage(images.v3.LivingRoomJoeVanessa2);
                vanessa.talk(`Knowing Ann, I can't really blame her.\nBut let's think about what really happened.`);
                vanessa.talk(`She likes you, right?`);
                ImageClass.setImage(images.v3.LivingRoomJoeVanessa2);
                mc.talk(`She said she does, yeah.`);
                vanessa.talk(`So she just saw the dick of a guy she likes...`);
                vanessa.talk(`So what? It's not like it wasn't going to happen anyway.`);
                mc.talk(`You have a point...`);
                vanessa.talk(`Yeah.\nStill, that was a pretty dumb move. HAHA.`);
                mc.talk(`Come on...`);
                vanessa.talk(`Haha sorry... I can't help myself. You've just made my day.`);
                mc.talk(`At least one of us is pleased.`);

            }

            ImageClass.setImage(images.v3.LivingRoomJoeVanessa3);
            joe.talk(`The four of us should meet more often.`);
            joe.talk(`${mc.name}, I'm going to text you Vanessa's number if you ever want to reach me and I'm not answering.`);
            joe.talk(`Anyway, it was fun.`);
            vanessa.talk(`I agree.`);
            joe.talk(`Well, it's time for us to get going.`);
            ImageClass.setImage(images.v3.LivingRoomJoeVanessa2);
            joe.talk(`Vanessa, are you ready?`);
            vanessa.talk(`Sure let's go.`);
            mc.talk(`Bye guys.`);

            return jump(LivingRoomJoeVanessaLeaving, "LivingRoomJoeVanessaLeaving");
        }

    };
    return jump(AfterTODBtns1, "AfterTODBtns1");
};
export const AfterTODBtns1 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    if (!Game.seenScenarios.includes(`AfterTODBtns1`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 35;
            properties.instaFollowers = 32500;
        });
    }
    await UI.add({
        key: "v3AfterTOD",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Go to the living room", key: "continue" }
            ]
    });
    if (UI._globalUI.v3AfterTOD === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v3AfterTOD === "continue") {
        return jump(AfterTODLivingRoomNotNaked, "AfterTODLivingRoomNotNaked");

    }
    return jump(AfterTODBtns1, "AfterTODBtns1");
};

export const AfterTODLivingRoomNotNaked = async (): Promise<any> => {
    ImageClass.setImage(images.v3.LivingRoomJoeVanessa1, { transition: true });

    joe.talk(`I was just about to check in with you.`);
    joe.talk(`We are heading out.`);
    if (mc.properties.annStatus === "hate") {

        mc.talk(`Sure.`);
        joe.talk(`I hope you had fun yesterday.`);

        if (Question.globalAnswers.todMCDareVanessa === "showBoobs") {
            ImageClass.setImage(images.v3.LivingRoomJoeVanessa2);
            vanessa.talk(`Of course he did, he got to see my boobs! Haha.`);
        } else {
            ImageClass.setImage(images.v3.LivingRoomJoeVanessa2);
            vanessa.talk(`Of course he did. He got to see my panties! Haha.`);
            joe.talk(`But you didn't have any!`);
            vanessa.talk(`Oh right.`);
            mc.talk(`...`);
            mc.talk(`Are you mad?`);
            ImageClass.setImage(images.v3.LivingRoomJoeVanessa3);
            joe.talk(`No, there is nothing I can do about that anyway.\nPlus it was part of the game.`);
        }


        ImageClass.setImage(images.v3.LivingRoomJoeVanessa3);
        mc.think(`Joey doesn't seem to care that his girl is exposing herself.`);
        joe.talk(`Too bad Ann left early.`);
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
            ImageClass.setImage(images.v3.LivingRoomJoeVanessa2);
            vanessa.talk(`I bet she went to see that Chris guy haha.`);
            joe.talk(`You think?`);
            vanessa.talk(`Nah, I was just joking, she wouldn't do that.`);
        } else {
            ImageClass.setImage(images.v3.LivingRoomJoeVanessa2);
            vanessa.talk(`I bet she went to study or some other boring shit.`);
            vanessa.talk(`${mc.name}, you really managed to piss her off.`);
            ImageClass.setImage(images.v3.LivingRoomJoeVanessa3);
            mc.talk(`I just told the truth.`);
            vanessa.talk(`Yeah sure, I can't blame you.`);
            mc.talk(`Thanks.`);
        }

    }
    if (mc.properties.annStatus !== "hate") {
        ImageClass.setImage(images.v3.LivingRoomJoeVanessa2);
        vanessa.talk(`Not before you tell us what happened!`);
        vanessa.talk(`Where is Ann? Still sleeping after a long night of rough sex?`);
        ImageClass.setImage(images.v3.LivingRoomJoeVanessa3);
        mc.talk(`Not exactly.\nAnd she left already.`);
        if (mc.properties.annStatus === "natural") {
            vanessa.talk(`What? When?`);
            mc.talk(`She must have snuck out when you guys were sleeping.`);
            vanessa.talk(`I bet she was too afraid to confront me!`);
            mc.talk(`Maybe...`);
        }
        vanessa.talk(`So??? What happened? You did spend the night together in the same bed.`);
        vanessa.talk(`Oh no, don't tell me you slept on the floor.`);
        vanessa.talk(`And what about my dare? Did you do it?`);
        mc.talk(`Wait, chill.`);
        joe.talk(`She is like that when she is excited.`);
        ImageClass.setImage(images.v3.LivingRoomJoeVanessa2);
        mc.talk(`And she just can't hide it.`);
        vanessa.talk(`Shhh....`);
        vanessa.talk(`${mc.name}!`);
        mc.talk(`Fine.`);
        mc.talk(`I didn't do my dare.`);
        vanessa.talk(`Coward.`);
        ImageClass.setImage(images.v3.LivingRoomJoeVanessa3);
        mc.talk(`It was a stupid dare.`);
        vanessa.talk(`It was, but you are still a coward for not doing it.`);
        mc.talk(`Anyway, nothing really happened, I went to sleep next to her.`);
        vanessa.talk(`Why didn't you start with that?`);
        mc.talk(`You didn't really let me talk...`);
        vanessa.talk(`Did you try to touch her?`);

        if (mc.properties.annStatus === "natural") {

            mc.talk(`Are you serious? I barely know her, I can't just touch her while she sleeps.`);
        } else {
            ImageClass.setImage(images.v3.LivingRoomJoeVanessa3);
            mc.talk(`No, I've learned a bit about her by now.`);
            mc.talk(`She wouldn't appreciate it.`);
            mc.talk(`Besides, that's straight-up creepy!`);
        }

        vanessa.talk(`That's a good point.`);


    }
    ImageClass.setImage(images.v3.LivingRoomJoeVanessa3);

    if (mc.properties.annStatus === "natural") {

        vanessa.talk(`Well, I'm going to be late for work.`);
    } else {

        joe.talk(`Anyway guys, the four of us should meet more often.`);
    }
    joe.talk(`It was fun.`);

    vanessa.talk(`I agree.`);
    joe.talk(`${mc.name}, I'm going to text you Vanessa's number if you ever want to reach me and I'm not answering.`);
    joe.talk(`We'll be going now.`);
    return jump(LivingRoomJoeVanessaLeaving, "LivingRoomJoeVanessaLeaving");
};
export const LivingRoomJoeVanessaLeaving = async (): Promise<any> => {

    ImageClass.setImage(images.v1.Room1, { transition: true });

    await mc.set((properties) => {
        global.toast?.show(`You now have Vanessa's number.`);
    });
    if (Question.globalAnswers.afterTODEnteredNaked) {
        pcLady.talk(`I should have listened the first time your told me the story, LOL!`, { method: "Over Chat" });
        pcLady.talk(`I can't believe you really slept next to Ann naked.`, { method: "Over Chat" });
        pcLady.talk(`I'm not surprised she ran away. What were you thinking?`, { method: "Over Chat" });
        mc.talk(`I was still in a game mood, it seemed like a good idea at the time.\nYou can't judge me.`, { method: "On Chat" });
        if (mc.properties.annStatus === "gf") {
            mc.talk(`Plus, things were going well for us, I thought she might be ready to step up her game.`, { method: "On Chat" });

        }
        pcLady.talk(`Maybe.`, { method: "Over Chat" });
        pcLady.talk(`I still agree with Vanessa that it was stupid.`, { method: "Over Chat" });
        mc.talk(`Are you serious? It was her idea in the first place.`, { method: "On Chat" });
        pcLady.talk(`From what you've told me about her, you should have known she was just playing with you.`, { method: "Over Chat" });
        mc.talk(`Maybe...`, { method: "On Chat" });
    } else {
        if (Question.globalAnswers.v25JoeTODAgree && mc.properties.annStatus === "gf") {
            pcLady.talk(`You really liked Ann.`, { method: "Over Chat" });
            mc.talk(`Yes, she is really cute.`, { method: "On Chat" });
            pcLady.talk(`It seems like things were working out well for you!`, { method: "Over Chat" });
            pcLady.talk(`Joe's new lifestyle worked out even in your favor.`, { method: "Over Chat" });
            mc.talk(`Yeah, you could say that.`, { method: "On Chat" });
        }
    }

    if (Question.globalAnswers.v25JoeTODAgree && mc.properties.annStatus === "gf") {
        pcLady.talk(`I can't believe you let Joe fool around with Ann like that.`, { method: "Over Chat" });
        mc.talk(`I don't really care about that.`, { method: "On Chat" });
        pcLady.talk(`Explain.`, { method: "Over Chat" });
        mc.talk(`There is nothing really to explain.`, { method: "On Chat" });
        mc.talk(`He fooled around with Ann and so did I with Vanessa.`, { method: "On Chat" });
        pcLady.talk(`Yeah, but you didn't really do anything with her besides watching her expose herself.`, { method: "Over Chat" });
        pcLady.talk(`Anyway, I hope you knew what you were doing.`, { method: "Over Chat" });
        mc.talk(`I did.`, { method: "On Chat" });

    }

    if (mc.properties.annStatus === "hate") {
        pcLady.talk(`You really fucked up your relationship with Ann.`, { method: "Over Chat" });
        mc.talk(`We didn't have much of one to begin with.`, { method: "On Chat" });
        mc.talk(`I gave it a chance, but it just didn't suit me.`, { method: "On Chat" });
        pcLady.talk(`I can understand, so it's over with her?`, { method: "Over Chat" });
        mc.talk(`Not just yet.`, { method: "On Chat" });
        pcLady.talk(`Oh! There is more!`, { method: "Over Chat" });
        mc.talk(`Yup.`, { method: "On Chat" });
    }

    if (!Question.globalAnswers.afterTODEnteredNaked && mc.properties.annStatus === "natural") {
        if (mc.properties.metAnn) {

            pcLady.talk(`So you met Ann for the first time and acted like you don't.`, { method: "Over Chat" });
            pcLady.talk(`You keep lying to your best friend.`, { method: "Over Chat" });
        } else {

            pcLady.talk(`So you kept lying to your best friend...`, { method: "Over Chat" });
        }

    }
    if (mc.properties.vanessaRelationship > 1) {
        pcLady.talk(`What about Vanessa?`, { method: "Over Chat" });
        mc.talk(`What about her?`, { method: "On Chat" });
        pcLady.talk(`It seems that you liked her.`, { method: "Over Chat" });
        mc.talk(`I did...`, { method: "On Chat" });
        pcLady.talk(`But she is your best friend's girlfriend.`, { method: "Over Chat" });
        mc.talk(`That made it even more complicated.`, { method: "On Chat" });
        pcLady.talk(`So what did you do about that?`, { method: "Over Chat" });
        mc.talk(`I'll get to it in a minute.`, { method: "On Chat" });
        pcLady.talk(`I'm curious...`, { method: "Over Chat" });
    }
    if (Question.globalAnswers.v2AgreeToSeeBJPic) {

        pcLady.talk(`Have you decided what you are going to do about Chris?`, { method: "Over Chat" });
        mc.talk(`Well, I had to decide if I wanted to confront Vanessa about him or just go and tell Joey what I knew.`, { method: "On Chat" });
        pcLady.talk(`It seems like a really tough decision.`, { method: "Over Chat" });
        mc.talk(`It really was.`, { method: "On Chat" });
        pcLady.talk(`Can't wait to hear!`, { method: "Over Chat" });
    }


    pcLady.talk(`Just continue with your story.`, { method: "Over Chat" });
    mc.talk(`Fine.`, { method: "On Chat" });

    mc.talk(`After Joey and Vanessa left, I went back to my room and spent some time on my computer.`, { method: "On Chat" });


    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
};

export const RoomAfterRecapBTNS = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone, { transition: true });
    if (Game.seenScenarios.includes("RoomAfterRecapBTNS")) {
        if (mc.properties.annStatus === "hate") {
            mc.think(`Ann is still angry at me, I don't know if she would want to see me...`);
            if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
                mc.think(`Chris seems to like her.`);
                mc.think(`Even though they don't seem like they really fit as a couple.`);
                mc.think(`They probably got even closer after Vanessa dared her to send him a selfie.`);
            }
            if (!mc.properties.knowsAlexAndAnnFriends && getInstaImage(Insta.instaProfiles?.[alex.name], `${alex.name}8`)?.mcSeen) {
                await mc.set((properties) => {
                    properties.knowsAlexAndAnnFriends = true;
                });
                mc.talk(`Now I know that Ann is a friend of Alex.`);
                mc.talk(`Maybe she could introduce me to her.`);
            }

        }

    }
    if (!Game.seenScenarios.includes(`RoomAfterRecapBTNS`)) {
        await alex.set((properties) => {
            properties.instaProfileImage = alexProfilesPic.alexInstaPortrait3;
            properties.instaFollowing = 55;
            properties.instaFollowers = 51200;
        });
    }

    await UI.add({
        key: "V3RoomAfterRecapBTNS",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.phone, tooltip: "Call Vanessa", key: "vanessa" },
                { image: uiImages.phone, tooltip: "Call Ann", key: "ann" },
                { image: uiImages.phone, tooltip: "Call Joey", key: "joey" },
            ]
    });
    if (UI._globalUI.V3RoomAfterRecapBTNS === "insta") {
        await Insta.open(getInstaData());
        if (Game.seenScenarios.includes(`RoomAfterRecapBTNS`)) {
            mc.think(`Alex is getting more popular with every day that passes.`);
        }
    }
    if (UI._globalUI.V3RoomAfterRecapBTNS === "vanessa") {
        return jump(v3CallVanessa, "v3CallVanessa");

    }
    if (UI._globalUI.V3RoomAfterRecapBTNS === "ann") {
        return jump(v3CallAnn, "v3CallAnn");

    }
    if (UI._globalUI.V3RoomAfterRecapBTNS === "joey") {
        return jump(v3CallJoey, "v3CallJoey");
    }

    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
};




export const v3CallAnn = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    if (Game.seenScenarios.includes(`AnnAfterTODLove1`)) {
        if (!Game.seenScenarios.includes(`JoeGym1`)) {

            mc.think(`I've already met with Ann.`);
            mc.think(`I should talk to Joey and see what he is doing.`);
        }
        return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
    }


    if (!Game.seenScenarios.includes(`RoomAfterRecapAnn`)) {


        if (!Game.seenScenarios.includes(`JoeGym1`)) {
            // Ann can't meet right now.

            if (!Game.seenScenarios.includes(`AnnAfterTODLove1`)) {

                if (mc.properties.annStatus === "natural") {
                    mc.think(`I'll give Ann a call.`);
                    mc.think(`Yesterday I learned that she likes Joey.`);
                    mc.think(`But I didn't really have the chance to get to know her with all that is going on.`);
                    return jump(RoomAfterRecapAnnStatus0, "RoomAfterRecapAnnStatus0");
                } else if (mc.properties.annStatus === "hate") {
                    ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
                    mc.think(`I should tell Ann she forgot her book at my place.`);
                    if (Question.globalAnswers.todAnnHateLivingRoomConv === "haveFun") {
                        mc.think(`She didn't take it kindly when I said I just wanna have fun when I was left alone with her.`);
                        mc.think(`But it is what it is.`);
                    } else {
                        mc.think(`I did apologize yesterday so she might forgive me.`);

                    }
                    if (!mc.properties.knowsAlexAndAnnFriends && getInstaImage(Insta.instaProfiles[alex.name], `${alex.name}8`)?.mcSeen) {
                        await mc.set((properties) => {
                            properties.knowsAlexAndAnnFriends = true;
                        });
                        mc.think(`And now I know she is a friend of Alex.`);
                        mc.think(`Maybe I can ask Ann about her...`);
                    }

                    ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
                    empty.think(`Calling Ann...`);
                    ImageClass.setImage(images.v1.RoomLookingAtPhone);
                    mc.think(`No answer...`);
                    mc.think(`I should try again later.`);

                    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
                }

                if (mc.properties.annStatus === "gf") {

                    mc.think(`Let's see what Ann is up to.`);
                    if (Question.globalAnswers.afterTODEnteredNaked) {

                        mc.think(`Things were going great between us until I fucked up and got in the bed naked.`);
                        mc.think(`Vanessa and her ideas...`);
                        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {

                            mc.think(`And there is that situation with that bartender.`);
                            mc.think(`But I bet I can get him off her if I want to.`);
                        }
                    } else {
                        mc.think(`Things are going great between us.`);
                        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {

                            mc.think(`Although there is that situation with that bartender.`);
                            mc.think(`But I bet I can get him off her if I want to.`);
                        }
                    }

                    mc.think(`I should give her a call.`);
                    if (!Question.globalAnswers.afterTODEnteredNaked) {

                        mc.think(`I just hope she answers after she ran away this morning.`);
                    }

                    return jump(RoomAfterRecapAnnStatus23, "RoomAfterRecapAnnStatus23");
                }

            }
            if (Question.globalAnswers.afterTODEnteredNaked) {
                ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
                empty.think(`Calling Ann...`);
                ImageClass.setImage(images.v1.RoomLookingAtPhone2);
                ann.talk(`Hey ${mc.name}.`, { method: "Over Phone" });
                mc.talk(`Hey Ann, what's up?`, { method: "On Phone" });
                ann.talk(`I'm doing fine.`, { method: "Over Phone" });
                ann.talk(`At the library trying to study...`, { method: "Over Phone" });
                ann.talk(`What about you?`, { method: "Over Phone" });
                mc.talk(`Well, I've been spending my time at home after you guys left.`, { method: "On Phone" });
                mc.talk(`I was wondering, would you like to come over?`, { method: "On Phone" });
                ann.talk(`Funny that you suggest it.`, { method: "Over Phone" });
                mc.talk(`How so?`, { method: "On Phone" });
                ann.talk(`I need to talk to you.`, { method: "Over Phone" });
                mc.talk(`Is that about this morning?`, { method: "On Phone" });
                ann.talk(`Yes, that's the main subject.`, { method: "Over Phone" });
                mc.talk(`You should come over then so we can talk.`, { method: "On Phone" });

                ann.talk(`I would, but I'm busy studying right now.`, { method: "Over Phone" });
                ann.talk(`Can I come later?`, { method: "Over Phone" });
                mc.talk(`Sure.`, { method: "On Phone" });
                ann.talk(`Alright I'll see you later then.`, { method: "Over Phone" });
                return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");

            } else {
                ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
                empty.think(`Calling Ann...`);
                ImageClass.setImage(images.v1.RoomLookingAtPhone2);
                ann.talk(`Hey ${mc.name}!`, { method: "Over Phone" });
                mc.talk(`Hey Ann, what's up?`, { method: "On Phone" });
                ann.talk(`I'm doing really well!`, { method: "Over Phone" });


                ann.talk(`Currently, at the library studying. I'm trying to catch up on some stuff I wasn't able to do in the last few days...`, { method: "Over Phone" });
                ann.talk(`It's been a very busy couple of days.`, { method: "Over Phone" });
                ann.talk(`But I don't regret it, hehe.`, { method: "Over Phone" });
                mc.talk(`Oh, so you are busy.`, { method: "On Phone" });
                ann.talk(`Right now I am... Yes.\nI won't be busy later.`, { method: "Over Phone" });
                mc.talk(`So you should come over when you have the chance.`, { method: "On Phone" });
                ann.talk(`Sure! Let me just finish some stuff and I'll come.`, { method: "Over Phone" });
                mc.talk(`Great! See you later.`, { method: "On Phone" });
                return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
            }


        }

        if (mc.properties.annStatus === "hate") {
            return jump(AnnAfterTODNotLove, "AnnAfterTODNotLove");

        }
        if (Question.globalAnswers.afterTODEnteredNaked) {
            ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
            empty.think(`Calling Ann...`);
            ImageClass.setImage(images.v1.RoomLookingAtPhone2);
            ann.talk(`Hey ${mc.name}.`, { method: "Over Phone" });
            mc.talk(`Hey Ann, what's up?`, { method: "On Phone" });
            ann.talk(`I'm doing fine.`, { method: "Over Phone" });
            ann.talk(`At the library trying to study...`, { method: "Over Phone" });
            ann.talk(`What about you?`, { method: "Over Phone" });
            mc.talk(`Well, I've been spending my time at home after you guys left.`, { method: "On Phone" });
            mc.talk(`I was wondering, would you like to come over?`, { method: "On Phone" });
            ann.talk(`Funny that you suggest it.`, { method: "Over Phone" });
            mc.talk(`How so?`, { method: "On Phone" });
            ann.talk(`I need to talk to you.`, { method: "Over Phone" });
            mc.talk(`Is that about this morning?`, { method: "On Phone" });
            ann.talk(`Yes, that's the main subject.`, { method: "Over Phone" });



            ann.talk(`Can I come right now?`, { method: "Over Phone" });
            mc.talk(`Now is good.`, { method: "On Phone" });
            ann.talk(`On my way.`, { method: "Over Phone" });
        } else {
            ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
            empty.think(`Calling Ann...`);
            ImageClass.setImage(images.v1.RoomLookingAtPhone2);
            ann.talk(`Hey ${mc.name}!`, { method: "Over Phone" });
            mc.talk(`Hey Ann, what's up?`, { method: "On Phone" });
            ann.talk(`I'm doing really well!`, { method: "Over Phone" });


            ann.talk(`Currently at home, I've been studying all morning, I'm trying to catch up on some stuff I wasn't able to do in the last few days...`, { method: "Over Phone" });
            ann.talk(`It's been a very busy couple of days.`, { method: "Over Phone" });

            ann.talk(`But I don't regret it, hehe.`, { method: "Over Phone" });
            mc.talk(`So, if you are free you should come over.`, { method: "On Phone" });
            ann.talk(`I'd love to!`, { method: "Over Phone" });
            ann.talk(`To be honest, I was going to suggest the same thing, you beat me to it. Hehe.`, { method: "Over Phone" });
            mc.talk(`Great!`, { method: "On Phone" });
            ann.talk(`Bye ${mc.name}, see you in a few!`, { method: "Over Phone" });
        }

        return jump(AnnAfterTODLove1, "AnnAfterTODLove1");




    } else {

        if (!Game.seenScenarios.includes(`JoeGym1`)) {
            //Can't meet with her and already talked to her
            if (mc.properties.annStatus === "natural") {
                mc.talk(`I've already tried calling her and she didn't answer.`);
                mc.talk(`I should try again later.`);
            }
            if (mc.properties.annStatus === "hate") {

                mc.talk(`I've already tried calling her and she didn't answer.`);
                mc.talk(`Maybe Joey isn't busy.`);
            }
            if (mc.properties.annStatus === "gf") {
                mc.talk(`I've already talked to Ann.`);
                mc.talk(`She said I should talk to her later.`);
                mc.talk(`Maybe Joey isn't busy.`);
            }

            return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
        }
        if (mc.properties.annStatus === "hate") {

            return jump(AnnAfterTODNotLove, "AnnAfterTODNotLove");
        }


        if (mc.properties.annStatus === "gf") {

            // A conversation after they already spoke and she couldn't come because mc didn't meet with Joey first
            mc.think(`Maybe Ann can meet right now.`);
            ImageClass.setImage(images.v1.RoomLookingAtPhone2);
            mc.talk(`Hey Ann.`);
            if (Question.globalAnswers.afterTODEnteredNaked) {

                ann.talk(`Hey ${mc.name}, Can I come over?`, { method: "Over Phone" });
                mc.talk(`Yes.`);
                ann.talk(`I'm coming...`, { method: "Over Phone" });
            } else {

                ann.talk(`Hey ${mc.name}! Can I come over?`, { method: "Over Phone" });
                mc.talk(`Sure.`);
                ann.talk(`On my way, hehe!`, { method: "Over Phone" });
            }


            return jump(AnnAfterTODLove1, "AnnAfterTODLove1");


        }
    }



    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");

};
export const RoomAfterRecapAnnStatus0 = async (): Promise<any> => {
    if (!Game.seenScenarios.includes(`JoeGym1`)) {

        ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
        empty.think(`Dialing Ann...`);
        ImageClass.setImage(images.v1.RoomLookingAtPhone2);
        empty.think(`...`);
        ImageClass.setImage(images.v1.RoomLookingAtPhone);
        mc.think(`No answer.`);
        mc.think(`I should try later.`);
    }
    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
};

export const RoomAfterRecapAnnStatus23 = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomLookingAtPhone2);

    if (Question.globalAnswers.afterTODEnteredNaked) {
        ImageClass.setImage(images.v1.RoomLookingAtPhone2);
        empty.think(`Calling Ann...`);
        ann.talk(`Hey ${mc.name}.`, { method: "Over Phone" });
        mc.talk(`Hey Ann, what's up?`, { method: "On Phone" });
        ann.talk(`I'm doing fine.`, { method: "Over Phone" });
        ann.talk(`At the library trying to study...`, { method: "Over Phone" });
        ann.talk(`What about you?`, { method: "Over Phone" });
        mc.talk(`Well, I've been spending my time at home after you guys left.`, { method: "On Phone" });
        mc.talk(`I was wondering, would you like to come over?`, { method: "On Phone" });
        ann.talk(`Funny that you suggest it.`, { method: "Over Phone" });
        mc.talk(`How so?`, { method: "On Phone" });
        ann.talk(`I need to talk to you.`, { method: "Over Phone" });
        mc.talk(`Is that about this morning?`, { method: "On Phone" });
        ann.talk(`Yes, that's the main subject.`, { method: "Over Phone" });
        if (!Game.seenScenarios.includes(`JoeGym1`)) {
            mc.talk(`You should come over so we can talk about that.`, { method: "On Phone" });

            ann.talk(`I would, but I'm busy studying right now.`, { method: "Over Phone" });
            ann.talk(`Can I come later?`, { method: "Over Phone" });
            mc.talk(`Sure.`, { method: "On Phone" });
            ann.talk(`Alright see you later.`, { method: "Over Phone" });
            return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
        }

        ann.talk(`Can I come right now?`, { method: "Over Phone" });
        mc.talk(`Now works.`, { method: "On Phone" });
        ann.talk(`On my way.`, { method: "Over Phone" });
    } else {
        ImageClass.setImage(images.v1.RoomLookingAtPhone2);
        empty.think(`Calling Ann...`);
        ann.talk(`Hey ${mc.name}!`, { method: "Over Phone" });
        mc.talk(`Hey Ann, what's up?`, { method: "On Phone" });
        ann.talk(`I'm doing really well!`, { method: "Over Phone" });


        if (!Game.seenScenarios.includes(`JoeGym1`)) {
            ann.talk(`Currently at the library studying, I'm trying to catch up on some stuff I wasn't able to do in the last few days...`, { method: "Over Phone" });
            ann.talk(`It's been a very busy couple of days.`, { method: "Over Phone" });
            ann.talk(`But I don't regret it, hehe.`, { method: "Over Phone" });
            mc.talk(`Oh, so you are busy.`, { method: "On Phone" });
            ann.talk(`Right now I am... Yes.\nI won't be busy later.`, { method: "Over Phone" });
            mc.talk(`So you should come over when you have the chance.`, { method: "On Phone" });
            ann.talk(`Sure! Let me just finish some stuff and I'll come over.`, { method: "Over Phone" });
            mc.talk(`Great! See you later.`, { method: "On Phone" });
            return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
        }


        ann.talk(`Currently at home, I've been studying all morning, I'm trying to catch up on some stuff I wasn't able to do in the last few days...`, { method: "Over Phone" });
        ann.talk(`It's been a very busy couple of days.`, { method: "Over Phone" });

        ann.talk(`But I don't regret it, hehe.`, { method: "Over Phone" });
        mc.talk(`So, if you are free you should come over.`, { method: "On Phone" });
        ann.talk(`I'd love to!`, { method: "Over Phone" });
        ann.talk(`To be honest, I was going to suggest the same thing, you beat me to it. Hehe.`, { method: "Over Phone" });
        mc.talk(`Great!`, { method: "On Phone" });
        ann.talk(`Bye ${mc.name}, see you in a few!`, { method: "Over Phone" });

    }


    return jump(AnnAfterTODLove1, "AnnAfterTODLove1");

};


export const v3CallJoey = async (): Promise<any> => {

    if (!Game.seenScenarios.includes(`JoeGym1`)) {
        if (!Game.seenScenarios.includes(`v3CallJoey`)) {
            ImageClass.setImage(images.v1.RoomLookingAtPhone2);
            mc.talk(`Hey Joey.`);
            joe.talk(`Hey, ${mc.name}, what's up?`);
            mc.talk(`I was wondering if you wanna meet.`);
            if (Question.globalAnswers.v1WentToTheBarWith === "vanessa" && !Game.seenScenarios.includes(`VanessaCoffee1`)) {

                joe.talk(`Sorry man I can't right now.`);
                joe.talk(`I'm on my way to the gym.`);
                joe.talk(`But talk to me in a couple of hours, we can meet at the gym.`);
                joe.talk(`The place is usually empty at this time, only a few people will be there.`);
                mc.talk(`Alright, I'll talk to you later.`);

                return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
            }

            joe.talk(`Sure, I just arrived at the gym and the place is pretty empty, only a couple of people.`);
            mc.talk(`I'll be right there.`);
            joe.talk(`Great!`);
        } else {
            if (Question.globalAnswers.v1WentToTheBarWith === "vanessa" && !Game.seenScenarios.includes(`VanessaCoffee1`)) {
                ImageClass.setImage(images.v1.RoomLookingAtPhone);
                mc.think(`Joey is busy right now, maybe I should see what's Vanessa is doing.`);
                return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
            }
            ImageClass.setImage(images.v1.RoomLookingAtPhone2);
            mc.talk(`Hey Joey, are you free right now?`);
            joe.talk(`Sure, are you coming?`);
            mc.talk(`On my way.`);
        }


        return jump(JoeGym1, "JoeGym1");
    }

    if (mc.properties.joeStatus === "enemy") {
        ImageClass.setImage(images.v1.RoomLookingAtPhone);
        mc.think(`No way I'm going to call him again right now... He is fucking pissed at me.`);
        return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
    }
    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    mc.think(`I've already talked to Joey.`);
    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");

};
export const v3CallVanessa = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    if (!Game.seenScenarios.includes(`VanessaCoffeeNoEVENT`) && !Game.seenScenarios.includes(`VanessaCoffee1`)) {
        if (!Game.seenScenarios.includes(`JoeGym1`)) {
            if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {

                return jump(VanessaCoffee1, "VanessaCoffee1");
            }

            return jump(VanessaCoffeeNoEVENT, "VanessaCoffeeNoEVENT");
        }
    }
    mc.talk(`I've already talked to Vanessa.`);
    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
};
export const VanessaCoffeeNoEVENT = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingVanessa);
    mc.think(`Let's see what Vanessa is doing.`);
    empty.think(`Dialing Vanessa...`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone2);
    vanessa.talk(`Hello?\nTalk fast.`);
    mc.talk(`Hey Vanessa, I was wondering what you are doing.`);
    vanessa.talk(`No time, getting ready for work, talk to you later.`);
    vanessa.talk(`Bye.`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    mc.think(`She hung up.`);
    return jump(RoomAfterRecapBTNS, "RoomAfterRecapBTNS");
};
export const RoomAfterEventsBTNS = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone, { transition: true });
    if (!Game.seenScenarios.includes(`RoomAfterEventsBTNS`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 55;
            properties.instaFollowers = 61234;
        });
    }
    if (mc.properties.annStatus !== "gf") {
        await ann.set((properties) => {
            properties.hasInsta = true;
        });

    }
    await UI.add({
        key: "v3End",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Pass Time", key: "continue" }
            ]
    });
    if (UI._globalUI.v3End === "insta") {
        getAlexInstaData(5);
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v3End === "continue") {

        const loveArray = (getInstaImage(Insta.instaProfiles?.[alex.name], `${alex.name}14`)?.mcComments?.filter(comment => {
            return love.concat(other).filter(loveWord => {
                return checkWordInArray(comment.toLocaleLowerCase(), loveWord);

            }).length > 0;
        }));
        if (!Game.seenScenarios.includes(`V3ShowAlexEasterEgg1`) && loveArray?.length) {
            return jump(V3ShowAlexEasterEgg1, "V3ShowAlexEasterEgg1");

        }
        return jump(V3Finish, "V3Finish");

    }

    ImageClass.setImage(images.v1.RoomComputerAlone, { transition: true });


    return jump(RoomAfterEventsBTNS, "RoomAfterEventsBTNS");
};
const love = [`i love you`, `i love u`, `i luv u`, `i luv you`, 'love u', 'love you', 'luv u', 'luv you'];
const other = [`sexy`, `hot`];


export const V3ShowAlexEasterEgg1 = async (): Promise<any> => {

    empty.think(`Beep beep.`);
    mc.think(`It's my phone...`);

    await Phone.showMessagesUI({ name: alex.name, profileImage: alexProfilesPic.alexInstaPortrait2 }, async () => {

        const loveArray = (getInstaImage(Insta.instaProfiles?.[alex.name], `${alex.name}14`)?.mcComments?.filter(comment => {
            return love.filter(loveWord => {
                return checkWordInArray(comment.toLocaleLowerCase(), loveWord);

            }).length > 0;
        }));

        if (loveArray?.length) {

            Phone.setMessage({ character: alex.character, text: `I LOVE YOU TOO!💗`, options: { wait: false } });
            alex.set((properties) => {
                properties.mcWroteLoveU = true;
            });
        }

        Phone.setMessage({ character: alex.character, text: `My friend took this photo of me while I was\nin the tanning bed. \nThe reason I haven't posted it was because\nit shows my face alongside my body.\nit's not much but I hope you like\nit. 😘😘😘.`, options: { wait: false } });
        Phone.setImage({ ...alexOtherPics.Alex14_2, character: alex.character, options: { wait: false } });
        Phone.setMessage({ character: alex.character, text: `I'll send you another photo of me very soon 😏.`, options: { wait: false } });



        Phone.closeMessagesUI();
    });


    return jump(RoomAfterEventsBTNS, "RoomAfterEventsBTNS");
};
export const V3Finish = async (): Promise<any> => {

    return jump(RoomAfterEventsPassedTime, "RoomAfterEventsPassedTime");


};